
export default[
   {
    path: '/0feeb20eafac6cf5a6ee99ac',
    children: [
     {
        path: "0fb65ef06132f6e0d084b3fb",
        name: "list-zonal-eos",
        meta: {
            title: "Zonal Examination Officers",
            authRequired: true,
            acc: ['y32394']
        },
        component: () => import("../views/zonalEO/index.vue"),
    },
    {
        path: "0f9180c10a0eae775b14ab97",
        name: "eos-zonal-new",
        meta: {
            title: "New Zonal Examination Officer",
            authRequired: true,
            acc: ['y41308']
        },
        component: () => import("../views/zonalEO/new.vue"),
    },
    {
        path: "101901ed2b94fab8ecbd0afa/:re",
        name: "view-zdo",
        meta: {
            title: "View Zonal Examination Officer",
            authRequired: true,
            acc: ['y16876']
        },
        component: () => import("../views/zonalEO/view.vue"),
    },
    {
        path: "10c00fd9eaed60cdeca0e928/:re/:tr",
        name: "edit-zdo",
        meta: {
            title: "Update Zonal Examination Officer",
            authRequired: true,
            acc: ['y46265']
        },
        component: () => import("../views/zonalEO/edit.vue"),
    }
    ]
   }

]